import { NewReview } from '@/domain/review'
import {
  OpsApiReviewItemsRequest,
  OpspbReview,
  OpspbRefundOverride
} from '@itsrever/rever-api'

export function toApiReviews(
  processId: string,
  reviews: NewReview[],
  refundOverride: OpspbRefundOverride
): OpsApiReviewItemsRequest {
  return {
    opspbReviewItemsRequest: {
      process_id: processId,
      reviews: toReviews(reviews),
      refund_override: refundOverride
    }
  }
}

function toReviews(reviews: NewReview[]): OpspbReview[] {
  return reviews.map((review) => ({
    line_item_id: review.lineItemId,
    location_id: review.location?.id,
    reject_reason: review.rejectReason,
    should_restock: review.shouldRestock,
    show_reject_reason: review.showRejectReason,
    status: review.status
  }))
}
